export const RECIPE_LISTING_GET_ALLERGENS = 'RECIPE_LISTING_GET_ALLERGENS';
export const RECIPE_LISTING_GET_ALLERGENS_ERROR =
  'RECIPE_LISTING_GET_ALLERGENS_ERROR';
export const RECIPE_LISTING_LOADING = 'RECIPE_LISTING_LOADING';



// WEBPACK FOOTER //
// ./src/pages/recipelisting/state/report/types.js